<template>
  <v-dialog persistent v-model="dialog" max-width="500px">
    <v-card>
      <v-card-title>
        <span class="headline">Novo Item</span>
      </v-card-title>

      <v-card-text class="pb-0">
        <v-container>
          <v-form ref="priceForm" v-model="valid" lazy-validation>
            <v-row>
              <v-col cols="12" sm="12">
                <v-text-field
                  color="secondary"
                  v-model="editedItem.object"
                  label="Objeto *"
                  :rules="requiredRule"
                  maxlength="255"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  color="secondary"
                  v-model="editedItem.quantity"
                  label="Quantidade *"
                  :rules="[
                    requiredRule[0],
                    numberRule[0],
                    positiveNumberRule[0],
                  ]"
                  v-mask="'###'"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field-money
                  color="secondary"
                  v-model="editedItem.unitPrice"
                  label="Valor Unitário *"
                  v-bind:properties="{
                  prefix:'R$',
                  }"
                  :rules="[requiredRule[0], currencyRule[0]]"
                ></v-text-field-money>
              </v-col>
              <v-col cols="12" sm="12">
                <v-text-field-money
                  color="secondary"
                  :value="calculateMoney"
                  label="Valor Total"
                  v-bind:properties="{
                  prefix:'R$',
                  }"
                  readonly
                ></v-text-field-money>
                <v-row v-if="calculateMoney + projectTotalPrice > 300000" class="warning-label">
                  Valor máximo permitido é R$ 300.000.
                </v-row>
              </v-col>
              <small>* Campo de preenchimento obrigatório</small>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="default" text @click="closeDialog">
          Cancelar
        </v-btn>
        <v-btn color="secondary" text @click="savePrice" :disabled="calculateMoney + projectTotalPrice > 300000">
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import VueMask from 'v-mask';

export default {
  props: {
    dialogChild: {
      required: true,
      type: Boolean,
    },
  },

  components: VueMask,

  data: () => ({
    valid: true,
    requiredRule: [v => !!v || 'Campo obrigatório'],
    numberRule: [v => /\d/g.test(v) || 'Somente números'],
    positiveNumberRule: [v => v > 0 || 'Valor mínimo: 1'],
    currencyRule: [v => /[\d,.]/g.test(v) || 'Somente dígitos monetários'],
    showTotalValueWarning: false,

    editedIndex: -1,
    editedItem: {
      id: null,
      object: '',
      quantity: null,
      unitPrice: null,
    },
    defaultItem: {
      id: null,
      object: '',
      quantity: null,
      unitPrice: null,
    },
    money: {
      decimal: ',',
      thousands: '.',
      precision: 2,
      masked: false
    }
  }),

  computed: {
    dialog() {
      return this.dialogChild;
    },
      calculateMoney() {
        return parseInt(this.editedItem.quantity, 10) * parseFloat(this.editedItem.unitPrice);
      },
      projectTotalPrice() {
        return this.$store.state.project.prices.reduce((total, price) => {
          const itemTotal = parseInt(price.quantity, 10) * parseFloat(price.unitPrice);
          return total + itemTotal;
        }, 0);
      },
    },

  methods: {
    validate() {
      return this.$refs.priceForm.validate();
    },
    reset() {
      this.$refs.priceForm.reset();
    },
    resetValidation() {
      this.$refs.priceForm.resetValidation();
    },
    closeDialog() {
      this.$emit('closeChild');
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
        this.resetValidation();
      });
    },
    savePrice() {
      if (this.validate()) {
        this.$emit('saveChild', this.editedItem);
        this.closeDialog();
      }
    },
    checkValue() {
      this.showTotalValueWarning = this.calculateMoney >= this.totalPriceThreshold;
    },
  },
  watch: {
    calculateMoney() {
      this.checkValue();
    },
  }
};
</script>

<style scoped>
form p {
  margin-bottom: 8px;
}
.warning-label {
  color: red;
  font-size: 16px;
}
</style>
